function isSpecialClick(event) {
  var isMiddleClick = event.button === 1;
  return isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}

export default isSpecialClick;


// WEBPACK FOOTER //
// ../node_modules/instantsearch.js/es/lib/utils/isSpecialClick.js